export var Variant = /*#__PURE__*/ function(Variant) {
    Variant["error"] = "error";
    Variant["warning"] = "warning";
    Variant["success"] = "success";
    Variant["info"] = "info";
    return Variant;
}({});
